import MuiContainer, { ContainerProps } from '@mui/material/Container';

export interface IContainerProps extends ContainerProps {}

const Container = (props: IContainerProps): JSX.Element => {
  return <MuiContainer {...props} />;
};

export default Container;
